<template>
  <a-select
    v-if="!data.systemType"
    v-model:value="selectValue"
    style="width: 100%"
    :disabled="disabled"
    :placeholder="$t('ep_admin_tips_select')"
    :getPopupContainer="triggerNode => triggerNode.parentNode.parentNode"
    allowClear
    @change="handleChange"
  >
    <a-select-option
      v-for="(item, index) in data.optionsList"
      :key="index"
      :value="item.id ? item.id : item.optionContent"
      >{{ item.optionContent }}</a-select-option
    >
  </a-select>
  <!-- 国家 省份 预览假数据 -->
  <a-select
    v-if="data.systemType"
    v-model:value="selectValue"
    style="width: 100%"
    :options="data.systemType === '1' ? countryList : stateList"
    :disabled="disabled"
    :field-names="{ label: 'label', value: 'value' }"
    :placeholder="$t('ep_admin_tips_select')"
    :getPopupContainer="triggerNode => triggerNode.parentNode.parentNode"
    @change="handleChange"
    allowClear
  ></a-select>
  <a-input
    v-model:value="otherValue"
    v-if="showOtherInput"
    :placeholder="data.remind"
    style="margin-top: 8px"
    @blur="handleChange"
    :maxlength="500"
    show-count
  />
</template>
<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'

const props = defineProps({
  data: {
    required: true,
    type: Object,
    default: {}
  },
  value: {
    required: true,
    type: String,
    default: undefined
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:value', 'change'])
const selectValue = ref(props.value)
const otherValue = ref('')
const countryList = ref([
  {
    label: 'country',
    value: '1'
  }
])
const stateList = ref([
  {
    label: 'state',
    value: '1'
  }
])

const showOtherInput = computed(() => {
  return props.data?.optionsList?.some(item => {
    if (item.id) {
      return item.id === selectValue.value && item.othersFlag === '1'
    } else {
      return item.optionContent === selectValue.value && item.othersFlag === '1'
    }
  })
})

// 暂定入参
const handleChange = value => {
  const str = {
    optionId: selectValue.value,
    otherContent: showOtherInput.value ? otherValue.value : '',
    othersFlag: showOtherInput.value ? '1' : undefined
  }
  emit('change', selectValue.value ? [str] : [])
}

onMounted(async () => {
  if (props.data.fieldValue) {
    selectValue.value = props.data.fieldValue[0]?.optionId
      ? props.data.fieldValue[0].optionId
      : undefined
    otherValue.value = props.data.fieldValue[0]?.otherContent
      ? props.data.fieldValue[0].otherContent
      : undefined
  }
})
</script>
